import { useState, useRef, useMemo } from 'react';
import cx from "classnames";

import { debounceEventHandler } from '../tools';

import "../styles/Filters.css";


export function SearchFilter({ value: initialValue = '', onChange, className }) {
    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => {
        setValue(e.target.value);
        onChange(e);
    };

    return (
        <div className={cx("SearchFilter", { active: value.length > 0 }, className)}>
            <i className="fa fa-search"></i>
            <input
                type="text"
                value={value}
                onChange={handleChange}
                autoComplete="off"
                placeholder="Search: Python, Ruby, Photoshop..."
                className="input form-control" />
        </div>
    );
}


export function LocationFilter({ value: initialValue = '', onChange, className }) {
    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => {
        setValue(e.target.value);
        onChange(e);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') onChange(e);
    };

    return (
        <div className={cx("LocationFilter", { active: value.length > 0 }, className)}>
            <i className="fa fa-globe" aria-hidden="true" />
            <input type="text"
                value={value}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                autoComplete="off"
                placeholder="Change Location"
                className="input form-control" />
        </div>
    );
}


export default function Filters({ onChange, params, className }) {
    const onChangeRef = useRef(onChange);
    const paramsRef = useRef(params);
    onChangeRef.current = onChange;
    paramsRef.current = params;

    const onSearchChange = useMemo(
        () => debounceEventHandler((e) => {
            onChangeRef.current({ ...paramsRef.current, search: e.target.value });
        }, 200),
        []
    );

    return (
        <div className={cx("flex flex-col bg-white z-[9]", className)}>
            <div className="flex py-[5px] pr-[10px] items-center">
                <SearchFilter value={params.search} onChange={onSearchChange} className="mr-[5px] flex-1" />
            </div>
        </div>
    );
}
